import React from 'react'
import PageHeader from '../components/PageHeader'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function Erhverv() {
  const targetGroups = [
    {
      title: 'Entreprenører & Byggefirmaer',
      desc: 'Hurtig og effektiv kabeltrækning på nybyggeri, logistikcentre, erhvervshaller og boligprojekter.',
      icon: 'fa-solid fa-trowel-bricks',
    },
    {
      title: 'El-installatører & Mestre',
      desc: 'Professionel underleverandør til spidsbelastninger, store kabeltræk efter kabelplan og arbejde i højden.',
      icon: 'fa-solid fa-plug-circle-check',
    },
    {
      title: 'Andre Håndværksvirksomheder',
      desc: 'Tømrer-, murer- eller malervirksomheder, der behøver en pålidelig elektriker til fælles projekter.',
      icon: 'fa-solid fa-hammer',
    },
    {
      title: 'Lager- & Erhvervsejendomme',
      desc: 'Virksomheder med højt til loftet, der har behov for regelmæssig service med saxelift eller bomlift.',
      icon: 'fa-solid fa-warehouse',
    },
  ]

  return (
    <div className="space-y-16">
      <PageHeader
        badge="B2B & Samarbejde"
        title="Erhverv, Entreprenører & El-installatører"
        subtitle="Erfaren samarbejdspartner med eget specialmaskinel til store kabeltræk, byggesager og professionelt højdearbejde."
        breadcrumb="Erhverv"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            {/* Scrape fidelity text */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>Samarbejde på tværs af fag og projekter</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                25 års erfaring fra små opgaver til 3-årige storsager
              </h2>

              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="text-base font-normal text-slate-900">
                  Samarbejde med både El-installatør virksomheder og andre Håndværksmestre er en stor del af min forretning. Mine 25 års erfaring som elektriker, både som service elektriker i mindre og større private opgaver og især som ny byg og renoverings elektriker for både privat og erhverv, gør jeg har prøvet det meste. Fra opgaver indenfor total renovering af sommerhuset til at planlægge, lede og fordele arbejdet i store byggesager der har taget op mod 3 år at gennemføre.
                </p>
                <p className="font-normal">
                  Ved de store opgaver har jeg udviklet et specielt kabel aftrækker system på en minilæsser. Når jeg trækker kabler på store byggerier trækker jeg op til 3 stk. ad gangen og op til ca. 2 km kabel om dagen. Her kan jeg tilbyde en pakkeløsning på Saxelift, 1,5 km kabelaftrækker og erfaren elektriker i store kabeltræk i de forskellige el områder. Jeg udføre meget gerne kabeltræk med kabelplan. Virkelig en undervurderet ressource ikke at investere i, da man fremtids sikre sin installation for hurtigere fejlfinding og nemmere udbygning/ombygning af installation.
                </p>
              </div>
            </div>

            {/* Målgrupper grid */}
            <div>
              <h3 className="text-xl font-extrabold text-slate-900 mb-6">
                Jakob samarbejder med
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {targetGroups.map((tg, i) => (
                  <div key={i} className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-2">
                    <div className="w-10 h-10 rounded-xl bg-[#18191D] text-[#E36C0A] flex items-center justify-center text-base">
                      <i className={tg.icon} aria-hidden="true" />
                    </div>
                    <h4 className="font-bold text-slate-900 text-base">{tg.title}</h4>
                    <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed">{tg.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Erhvervsfordele */}
            <div className="bg-[#18191D] text-white rounded-3xl p-8 sm:p-10 shadow-xl border border-white/10 space-y-6">
              <h3 className="text-2xl font-extrabold tracking-tight">
                Fordele for erhvervskunder og samarbejdspartnere
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs sm:text-sm text-[#86878D]">
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-white block font-medium">Korte beslutningsveje</strong>
                    <span>Direkte kontakt til Jakob uden bureaukrati eller forsinkelser.</span>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-white block font-medium">Specialmaskiner til rådighed</strong>
                    <span>Minilæsser med kabeludtrækker og to egne lifte på trailer.</span>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-white block font-medium">Høj trækkapacitet</strong>
                    <span>Op til 2 km kabel om dagen – væsentlig besparelse på store pladser.</span>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A] mt-2 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="text-white block font-medium">Fuldt forsikret</strong>
                    <span>Tryghed på byggepladsen for bygherre og hovedentreprenør.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-[#2D346E]/60 space-y-6">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Erhvervskontakt</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white mt-1">
                  Skal vi samarbejde?
                </h3>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Ring og hør nærmere om Jakobs tilgængelighed til dit næste byggeprojekt eller kabeltræk.
                </p>
              </div>

              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                <span>Ring: {COMPANY_INFO.phone}</span>
              </a>

              <div className="pt-4 border-t border-[#2D346E]/60 space-y-2 text-xs text-[#9FA6D9]">
                <div className="flex items-center justify-between">
                  <span>CVR:</span>
                  <strong className="text-white font-bold">{COMPANY_INFO.cvr}</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Timepris:</span>
                  <strong className="text-white font-bold">485 kr. ex. moms</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Servicevogn:</span>
                  <strong className="text-emerald-400 font-bold">Inkluderet</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Skjulte tillæg:</span>
                  <strong className="text-emerald-400 font-bold">Ingen</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Price Banner */}
        <PriceBanner showCablePrice={true} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
